import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { AppVersionService } from '../services/app-version.service';
import { ServiceWorkService } from '../services/service-work.service';

@Injectable({ providedIn: 'root' })
export class ServiceWorkInterceptor implements HttpInterceptor {
  private serviceWorkService = inject(ServiceWorkService);
  private appVersionService = inject(AppVersionService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const isUnreachable =
          error.status === 0 || error.status === HttpStatusCode.ServiceUnavailable;

        if (isUnreachable && !this.appVersionService.isAbortedByReload(error)) {
          this.serviceWorkService.openServicePage();
        }

        return throwError(() => error);
      }),
    );
  }
}
